import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { readableColor } from "polished"

import { rhythm } from "@utils/typography"

const Media = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  & > div {
    display: flex;
    height: 100% !important;
    flex: 1 1 auto;
    margin-bottom: 0;
    img {
      margin-bottom: 0;
      height: 100%;
      width: auto;
    }
  }
`

const Text = styled(Box)`
  background-color: ${props => props.background || props.theme.color};
  color: ${props => readableColor(props.background || props.theme.color)};
  display: flex;
  flex-direction: column;
  flex: 1 1 60%;
  padding: ${rhythm(1)};
  & > blockquote {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`

const Wrapper = styled(Flex)`
  margin: ${props => (props.nospace ? false : rhythm(2))};
`

export { Media, Text, Wrapper }
